import React from "react";
import { FormGroup, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";

import Input from "../../../../components/common/input/Input";
import Button from "../../../../components/common/button/Button";
import Error from "../../../../components/common/error/Error";
import { required, email } from "../../../../utils/forms/validators";
import styles from "./ForgotPassword.scss";

import { FORGOT_PASSWORD_FORM } from "../../../../actions/forgotPassword.actions";

const emailValidation = email("Please enter a valid email address.");

class ForgotPassword extends React.Component {
  componentDidMount() {
    this.props.blur("email", _.get(this.props.location, "query.emailValue"));
  }

  render() {
    const { invalid, submitting, pristine, handleSubmit } = this.props;

    return (
      <section>
        <section className={styles.forgotPassword}>
          <div className={styles.content}>
            <h2 className={styles.title}>Forgot Your Password?</h2>

            <Form onSubmit={handleSubmit}>
              <div className={styles.form}>
                <div className={styles.subtitle}>
                  <span>No worries. It happens to the best of us.</span>
                </div>

                <FormGroup>
                  <Field
                    name="email"
                    type="text"
                    placeholder="Email Address"
                    component={Input}
                    validate={[required, emailValidation]}
                  />
                </FormGroup>

                <Button
                  isDisabled={invalid || submitting || pristine}
                  isPrimary
                  type="submit"
                  size="large"
                  label="Reset your password"
                />

                <Error />

                <div className={styles.subtitle}>
                  <span>
                    <Link to="/log-in">Go back to login</Link>
                  </span>
                </div>
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

export default reduxForm({
  form: FORGOT_PASSWORD_FORM
})(ForgotPassword);



// WEBPACK FOOTER //
// ./src/routes/common/ForgotPassword/components/ForgotPassword.js